import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89d706e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 3 }
const _hoisted_4 = { key: 4 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_a_card, { title: "分销商品" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_table, {
            dataSource: _ctx.list,
            columns: $setup.columns,
            bordered: "",
            pagination: $setup.pagination,
            onChange: $setup.handleTableChange,
            style: {"margin-top":"10px"}
          }, {
            bodyCell: _withCtx(({ column, record }) => [
              (column.key === 'image')
                ? (_openBlock(), _createBlock(_component_a_image, {
                    key: 0,
                    src: record.goods.image,
                    style: {"height":"30px"}
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              (column.key === 'name')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(record.goods.name), 1))
                : _createCommentVNode("", true),
              (column.key === 'max_price')
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(record.goods.max_price), 1))
                : _createCommentVNode("", true),
              (column.key === 'min_price')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(record.goods.min_price), 1))
                : _createCommentVNode("", true),
              (column.key === 'action')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_a_button, {
                      size: "small",
                      onClick: ($event: any) => ($setup.edit(record)),
                      type: "link"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_a_popconfirm, {
                      title: "是否删除该商品?",
                      onConfirm: ($event: any) => ($setup.onDel(record))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          size: "small",
                          style: {"margin":"5px"},
                          type: "text",
                          danger: ""
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onConfirm"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["dataSource", "columns", "pagination", "onChange"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visable,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visable) = $event)),
      title: "编辑商品",
      onOk: $setup.handleOk
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: _ctx.editData,
          name: "basic",
          "label-col": { span: 4 },
          "wrapper-col": { span: 20 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "分佣比例",
              name: "ratio"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.editData.ratio,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editData.ratio) = $event)),
                  placeholder: "分佣比例"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "排序",
              name: "sort"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.editData.sort,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editData.sort) = $event)),
                  placeholder: "排序"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ], 64))
}